
import "./ErrorPage.scss";
import { Link, useParams, useSearchParams } from "react-router-dom";
import { wdpUtil } from "../../common/utils/util";
import { createPageTestId } from "../../common/utils/testIds";
export const ErrorPage = () => {
    
    const { errorCode } = useParams();
    const [searchParams] = useSearchParams();
    
    // Get error code from URL params, query string, or default to '404'
    const code = errorCode || searchParams.get('code') || '404';
    
    function populateErrMsg(){
       return ( <h3 data-testid={createPageTestId('error-message')}>{`${code} ${wdpUtil.getErrMsg(parseInt( code as string))}`}</h3>
    );
    }

    return (
    <div className="error-content" data-testid={createPageTestId('error')}>
      <h1 data-testid={createPageTestId('error-title')}>Alberta Wildfire Fireline Equipment Time Ticket</h1>
      {populateErrMsg()}
      
      {code === '404' && 
      <p data-testid={createPageTestId('error-404-text')}>You are currently unable to access this page because the page does not exist anymore. <Link to="/" data-testid={createPageTestId('error-404-link')}>Click here</Link> to return to the application dashboard.</p>
      }
      {code === '500' && <p data-testid={createPageTestId('error-500-text')}>You are currently unable to access this page because of an internal server error. <Link to="/" data-testid={createPageTestId('error-500-link')}>Click here</Link> to return to the application dashboard.</p>}
      <br />
      <p data-testid={createPageTestId('error-contact')}> If you have any questions please contact: Wildfire Applications Support via <a href="mailto:wildfire.applications@gov.ab.ca" data-testid={createPageTestId('error-email')}> wildfire.applications@gov.ab.ca</a> or +1 780-427-8100 .</p>
    </div>
    )
}


